import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonOlList from '../../../common-components/common-ol-list';

const processPreviewList = {
    colorNumber: '#74c8da',
    list: [
        'Провести бизнес-анализ',
        'Прототипировать интерфейсы и&nbsp;собрать обратную связь по&nbsp;ним от&nbsp;целевых групп (Преподаватель и&nbsp;Участники конкурса)',
        'Разработать архитектуру платформы',
        'Запустить в&nbsp;кратчайшие сроки MVP платформы',
        'Отладить процессы в&nbsp;ходе обучения алгоритмов участников',
    ],
};

const processList = {
    colorNumber: '#7927E0',
    list: [
        'Сервис &laquo;Разметчик&raquo;,',
        'Сервис &laquo;Валидатор&raquo;,',
        'Систему проверки решений,',
        'Модуль &laquo;Персональный Комплекс Участника&raquo;,',
        'Программу Сравнения Решений.',
    ],
};

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <div className="upgreat-process__preview-wrap">
                <FullWrapper smallPaddings={true}>
                    <div className="upgreat-process__preview">
                        <div className="upgreat-process__text">
                            <CommonTitle>Процесс</CommonTitle>
                            <CommonUsualText className="upgreat-process__subtitle">
                                Чтобы запустить платформу вовремя,&nbsp;нам&nbsp;предстояло
                            </CommonUsualText>
                        </div>
                        <div className="upgreat-process__info">
                            <div className="upgreat-process__list">
                                <CommonOlList
                                    CommonOlList={processPreviewList}
                                    className="upgreat-proces__list"
                                ></CommonOlList>
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </div>
            <FullWrapper bigPaddings={false}>
                <div className="upgreat-process__content">
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="upgreat-process__item">
                            <div className="upgreat-process__item-info">
                                <CommonTitle className="upgreat-process__item-title">
                                    Архитектура платформы
                                </CommonTitle>
                                <CommonSmallText className="upgreat-process__paragraph">
                                    Платформа должна сравнить&nbsp;то, как тексты проанализировал
                                    программный комплекс, с&nbsp;анализом специалистов-учителей.
                                    Поэтому для старта испытаний на&nbsp;платформе нужны:
                                </CommonSmallText>
                            </div>
                            <div className="needs">
                                <div className="needs__item">
                                    <img
                                        className="needs__img"
                                        src="/images/svg/upgreat/texts.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                    <p className="needs__name">Тексты</p>
                                </div>
                                <div className="needs__item">
                                    <img
                                        className="needs__img"
                                        src="/images/svg/upgreat/teachers.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                    <p className="needs__name">Учителя</p>
                                </div>
                                <div className="needs__item">
                                    <img
                                        className="needs__img"
                                        src="/images/svg/upgreat/tools.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                    <p className="needs__name">
                                        Инструменты для&nbsp;анализа&nbsp;текстов
                                    </p>
                                </div>
                            </div>
                            <CommonSmallText>
                                <span className="upgreat-process__text-bold">
                                    Как это происходит у&nbsp;людей, а&nbsp;не&nbsp;роботов?
                                </span>{' '}
                                Учитель выделяет красным ошибки, &laquo;на&nbsp;полях&raquo;
                                поясняет, в&nbsp;чем ошибка заключается. Но&nbsp;проверяющие, прежде
                                всего,&nbsp;&mdash; люди. А&nbsp;значит, могут формулировать одни
                                и&nbsp;те&nbsp;же мысли разными словами. Человек-читатель поймет
                                смысл в&nbsp;любом случае, а&nbsp;вот искусственный
                                интеллект&nbsp;&mdash; нет.
                            </CommonSmallText>
                            <CommonSmallText>
                                Учителей, тексты, технический регламент, который описывал
                                математику, и&nbsp;классификатор ошибок нам предоставил заказчик.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="upgreat-process__item">
                            <CommonTitle className="upgreat-process__item-title">
                                Браузерный сервис &laquo;Разметчик&raquo;
                            </CommonTitle>
                            <CommonUsualText className="upgreat-process__paragraph">
                                Он&nbsp;помогает специалистам выделять смысловые блоки в&nbsp;тексте
                                и&nbsp;оставлять единообразные комментарии с&nbsp;описанием ошибки,
                                сверяясь&nbsp;с{' '}
                                <a
                                    className="upgreat-process__link"
                                    href="http://ai.upgreat.one/upload/iblock/cab/AI_Technical_Regulations.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Классификатором
                                </a>
                                .
                            </CommonUsualText>
                            <img
                                className="upgreat-process__img upgreat-process__img--first"
                                src="/images/pic/upgreat/process-1.jpg"
                                alt=""
                                loading="lazy"
                            />
                            <CommonSmallText>
                                <p>
                                    Разметчик был запущен в&nbsp;июле. Разметки специалистов
                                    мы&nbsp;назвали Экспертными. Самих проверяющих объединили
                                    в&nbsp;группу пользователей Редакторы. Запустить сервисы для
                                    Участников было необходимо не&nbsp;позднее 29&nbsp;сентября.
                                </p>
                                <p>
                                    Сначала мы загрузили в систему разработанные совместно с
                                    партнерами конкурса тестовые и обучающие датасеты. Чтобы
                                    программные комплексы конкурсантов смогли в&nbsp;реальном
                                    времени передавать размеченные файлы на платформу для испытаний,
                                    был разработан модуль Программный Комплекс Участника (ПКУ).
                                </p>
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="upgreat-process__item">
                            <CommonTitle className="upgreat-process__item-title">
                                Программный Комплекс Участника (ПКУ)
                            </CommonTitle>
                            <CommonUsualText className="upgreat-process__paragraph">
                                В&nbsp;ПКУ входит консольная утилита и&nbsp;два пакета данных.
                            </CommonUsualText>
                            <CommonSmallText className="upgreat-process__paragraph">
                                PSR&nbsp;&mdash; c&nbsp;метриками сравнения, Criteria&nbsp;&mdash;
                                c&nbsp;критериями точности разметки (метрики и&nbsp;критерии даны
                                в&nbsp;техническом регламенте от&nbsp;организаторов). Архивы для
                                скачивания доступны в&nbsp;личном кабинете Участника и&nbsp;на{' '}
                                <a
                                    className="upgreat-process__link"
                                    href="https://github.com/upgreat-readable/pku"
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                >
                                    GitHub
                                </a>
                                .
                            </CommonSmallText>
                            <CommonSmallText className="upgreat-process__paragraph">
                                Используя ПКУ, Участник может в&nbsp;любой момент через API
                                установить сессию между своим локальным устройством
                                и&nbsp;платформой. Последняя по&nbsp;запросу отдаёт файлы
                                с&nbsp;неразмеченным эссе. Затем на&nbsp;локальном устройстве
                                алгоритм участника размечает их&nbsp;и&nbsp;передает обратно. Пакет
                                парсера собирает разметку и&nbsp;преобразует в&nbsp;машиночитаемую
                                JSON-структуру.
                            </CommonSmallText>
                            <img
                                className="upgreat-process__img"
                                src="/images/pic/upgreat/process-2.jpg"
                                alt=""
                                loading="lazy"
                            />
                            <CommonSmallText>
                                Чтобы Участники были независимы от&nbsp;языка платформы
                                (TypeScript), мы&nbsp;&quot;завернули&quot;‎ приложение
                                и&nbsp;пакеты в&nbsp;Docker-контейнер и&nbsp;предоставили к&nbsp;ним
                                готовый консольный интерфейс. Его можно использовать из&nbsp;любого
                                языка программирования.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="upgreat-process__item">
                            <CommonSmallTitle className="upgreat-process__subtitle">
                                Данные сессии и&nbsp;результаты проверки размеченных файлов
                                отображаются в&nbsp;ЛК&nbsp;Участника.
                            </CommonSmallTitle>
                            <CommonSmallText>
                                Пользователь может скачать отчёт и&nbsp;логи, посмотреть
                                в&nbsp;визуальном интерфейсе, чем отличается его вариант разметки
                                от&nbsp;Экспертной.
                            </CommonSmallText>
                            <img
                                className="upgreat-process__img"
                                src="/images/pic/upgreat/process-3.jpg"
                                alt=""
                                loading="lazy"
                            />
                            <CommonSmallText>
                                Когда на&nbsp;платформу приходят размеченные файлы, включается
                                автоматическая система проверки решений, которая анализирует
                                присланные разметки, сравнивая с&nbsp;Экспертными. Это
                                алгоритмическая квалификация.
                            </CommonSmallText>
                            <img
                                className="upgreat-process__img"
                                src="/images/pic/upgreat/process-4.jpg"
                                alt=""
                                loading="lazy"
                            />
                            <CommonSmallText>
                                Кроме того, система проверяет состояние подключенного ПКУ каждые
                                4&nbsp;часа и&nbsp;оценивает его готовность к&nbsp;работе. Этот
                                процесс&nbsp;&mdash; техническая квалификация, имитирующая финальные
                                состязания.
                            </CommonSmallText>
                            <img
                                className="upgreat-process__img"
                                src="/images/pic/upgreat/process-5.jpg"
                                alt=""
                                loading="lazy"
                            />
                            <CommonSmallText>
                                Чтобы снизить нагрузку на&nbsp;Систему проверки решений,
                                мы&nbsp;разработали вспомогательный инструмент&nbsp;&mdash;
                                Валидатор. Он&nbsp;автоматически проверяет присланные файлы
                                на&nbsp;наличие логических ошибок в&nbsp;разметке и&nbsp;высылает
                                Участнику багрепорт.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="upgreat-process__item">
                            <CommonTitle className="upgreat-process__item-title">
                                Программа сравнения решений (ПСР)
                            </CommonTitle>
                            <CommonUsualText className="upgreat-process__paragraph">
                                Для проведения финальных испытаний 9&nbsp;ноября 2020&nbsp;мы
                                разработали отдельный сервис&nbsp;&mdash; Программу Сравнения
                                Решений (ПСР).
                            </CommonUsualText>
                            <CommonSmallText>
                                <p>
                                    Он&nbsp;представляет собой worker, который считывает задачи
                                    из&nbsp;сервера очередей и&nbsp;сохраняет результаты в&nbsp;базу
                                    датасетов. Она хранится на&nbsp;отказоустойчивом облаке Yandex
                                    Object Storage. Логи сессий отправляются в&nbsp;ELK стек.
                                </p>
                                <p>
                                    Сохраненные файлы с&nbsp;алгоритмической разметкой проверяют
                                    20&nbsp;лучших специалистов из&nbsp;числа тех, кто делал
                                    Экспертную разметку. За&nbsp;результатами проверки Участники
                                    могли следить на&nbsp;Лидерборде в&nbsp;личном кабинете.
                                </p>
                            </CommonSmallText>
                            <img
                                className="upgreat-process__img"
                                src="/images/pic/upgreat/process-6.jpg"
                                alt=""
                                loading="lazy"
                            />
                            <CommonSmallText>
                                <p>
                                    Лидерборд динамически обновляется через сервис финала
                                    и&nbsp;квалификаций с&nbsp;websocket-интерфейсом для платформы
                                    и&nbsp;http-интерфейсом для скачивания и&nbsp;загрузки файлов
                                    датасетов с&nbsp;выданным токеном. В&nbsp;этом сервисе хранится
                                    информация по&nbsp;финалу и&nbsp;квалификациям, он&nbsp;отвечает
                                    за&nbsp;выдачу файлов датасетов с&nbsp;необходимыми таймаутами
                                    и&nbsp;сохранение данных (для статистики).
                                </p>
                                <p>
                                    В&nbsp;день состязаний команды, успешно прошедшие квалификацию,
                                    одновременно установили сессии с&nbsp;платформой, используя ПКУ.
                                    В&nbsp;режиме реального времени их&nbsp;алгоритмы получали файлы
                                    от&nbsp;платформы, размечали в&nbsp;них тексты и&nbsp;возвращали
                                    обратно. Испытания длились более 8&nbsp;часов, а&nbsp;точнее,
                                    500&nbsp;минут, из&nbsp;расчета по&nbsp;минуте на&nbsp;файл. Для
                                    финала были использованы датасеты с&nbsp;новыми текстами,
                                    которые не&nbsp;использовались для обучения на&nbsp;этапе
                                    квалификаций.
                                </p>
                            </CommonSmallText>
                            <img
                                className="upgreat-process__img"
                                src="/images/pic/upgreat/process-7.jpg"
                                alt=""
                                loading="lazy"
                            />
                            <CommonSmallTitle>
                                Итого, в&nbsp;ходе разработки платформы мы&nbsp;создали:
                            </CommonSmallTitle>
                            <CommonOlList CommonOlList={processList}></CommonOlList>
                            <CommonSmallText>
                                <p>
                                    А&nbsp;также пакеты данных, вспомогательные микросервисы,
                                    мануалы и&nbsp;техническую документацию. Как и&nbsp;хотел
                                    заказчик, наши решения имеют открытый код, ознакомиться
                                    с&nbsp;которым и&nbsp;дать фидбэк можно&nbsp;на{' '}
                                    <a
                                        className="upgreat-process__link"
                                        href="https://github.com/upgreat-readable"
                                        target="_blank"
                                        rel="noopener noreferrer nofollow"
                                    >
                                        GitHub
                                    </a>
                                    .
                                </p>
                                <p>
                                    Системы личных кабинетов на&nbsp;платформе получилось две,
                                    с&nbsp;разной архитектурой и&nbsp;функционалом.
                                    С&nbsp;визуальным интерфейсом, но&nbsp;без программного для
                                    Редакторов и&nbsp;с&nbsp;обоими для Участников.
                                </p>
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
